/**
 * API Configuration Utility
 * 
 * Automatically determines the correct API base URL based on the current environment:
 * - Development (localhost): Uses REACT_APP_BACKEND_URL from .env
 * - Production: Uses the current window origin (same domain)
 * 
 * This ensures the app works correctly regardless of deployment environment.
 */

const getApiBaseUrl = () => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }

  const { hostname } = window.location;
  
  // Development environment - use env variable
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  
  // Emergent preview environment - use env variable (set correctly during preview builds)
  if (hostname.includes('.preview.emergentagent.com')) {
    return process.env.REACT_APP_BACKEND_URL || window.location.origin;
  }
  
  // Production or any other environment - use current origin
  // This ensures API calls go to the same domain the user is on
  return window.location.origin;
};

// Export the base URL (without /api suffix - components add that as needed)
export const API_BASE_URL = getApiBaseUrl();

// Export a version with /api suffix for convenience
export const API_URL = `${getApiBaseUrl()}/api`;

// Default export for backwards compatibility
export default API_BASE_URL;
